module.exports = __webpack_public_path__ + "static/img/306_TO8_2289_og.5addc6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/306_TO8_2289_og.jpg
// module id = pEnY
// module chunks = 0